import { createContext, useContext } from "react";

/**
 * Soft locks on long text fields, for the views (brief 8.3). A field someone else is typing in is
 * read-only here and says who has it. Focusing a field asks for its lock; leaving it gives it back.
 */
export interface FieldLocksValue {
  /** The name of whoever else is typing in the field, or null. */
  lockedBy(fieldPath: string): string | null;
  focus(fieldPath: string): void;
  blur(fieldPath: string): void;
}

const NONE: FieldLocksValue = {
  lockedBy: () => null,
  focus: () => undefined,
  blur: () => undefined,
};

export const FieldLocksContext = createContext<FieldLocksValue>(NONE);

export function useFieldLocks(): FieldLocksValue {
  return useContext(FieldLocksContext);
}
